import { downloadFile } from './native-platform.js';
import { readLocalExport, exportChecksum } from './local-export-store.js';
import type { ExportFormat } from './export-preparation.js';

function tokenKey(exportFlowId: string): string {
  return `drawonamap.preparedExport.${exportFlowId}`;
}

export function rememberPreparedExportToken(exportFlowId: string, token: string): void {
  if (!/^[a-f0-9]{64}$/.test(exportFlowId) || !/^[a-f0-9]{64}$/.test(token)) return;
  try { window.sessionStorage.setItem(tokenKey(exportFlowId), token); } catch {}
  try { window.localStorage.setItem(tokenKey(exportFlowId), token); } catch {}
}

export async function downloadPreparedExport(exportFlowId: string, format: ExportFormat, onLocalFileMissing?: () => void): Promise<boolean> {
  let token: string | null = null;
  try { token = window.sessionStorage.getItem(tokenKey(exportFlowId)); } catch {}
  if (!token) try { token = window.localStorage.getItem(tokenKey(exportFlowId)); } catch {}
  if (!token) return false;
  try {
    const local = await readLocalExport(exportFlowId);
    if (local && local.format === format) {
      const authorization = await fetch(`/api/exports/pending/${encodeURIComponent(exportFlowId)}`, {
        method: 'HEAD', headers: { Authorization: `Bearer ${token}` }, signal: AbortSignal.timeout(30_000),
      });
      if (!authorization.ok || authorization.headers.get('X-Export-Format') !== format
        || authorization.headers.get('X-Export-Sha256') !== await exportChecksum(local.blob)) return false;
      return await downloadBlob(local.blob, format);
    }
    const response = await fetch(`/api/exports/pending/${encodeURIComponent(exportFlowId)}`, {
      headers: { Authorization: `Bearer ${token}` }, signal: AbortSignal.timeout(180_000),
    });
    if (response.status === 410) { onLocalFileMissing?.(); return false; }
    if (response.status !== 200) return false;
    const blob = await response.blob();
    return await downloadBlob(blob, format);
  } catch {
    return false;
  }
}

function downloadBlob(blob: Blob, format: ExportFormat): Promise<boolean> {
  return downloadFile(blob, `drawonamap-map-${Date.now()}.${format}`);
}
